import type { CourseBuilderFormState } from "@store/slices/courseBuilderSlice";
import type { CourseCategoryGroupItem } from "../types";
import { createDefaultAttachmentItem } from "./courseAttachmentUtils";
import { normalizeCourseFormDurationUnit } from "../constants/durationUnits";

/**
 * Prefill step-1 basics from a GET /institutes/course/categories row (Add New Content flow).
 * Steps 2–6 remain empty for the user to complete.
 */
export function mapCategoryToCourseBuilderState(category: CourseCategoryGroupItem): CourseBuilderFormState {
	const courseStreamId = category.courseStreamId ?? category.courseStream?.id;
	const sectorId = category.sectorId ?? category.sector?.id;

	return {
		courseDetails: {
			courseName: category.name?.trim() ?? "",
			courseType: courseStreamId != null ? String(courseStreamId) : "",
			courseLevel: "",
			duration: category.duration != null ? String(category.duration) : "",
			durationUnit: normalizeCourseFormDurationUnit(category.durationUnit),
			totalStudentsCount: 0,
			sector: sectorId != null ? String(sectorId) : "",
			sectorName: category.sector?.name?.trim() ?? "",
			teachingMode: "",
			courseNotifyingAuthorityId: "",
			description: "",
			overview: "",
			lastReview: "",
			eligibilityCriteria: "",
			courseMode: "true",
			// Category list `id` / `categoryNo` are course-group ids — not `course_category` FK.
			courseCategoryId: "",
			courseCategoryName: category.name?.trim() ?? "",
			subjectIds: [],
			subjectItems: [],
			assessmentBodyIds: [],
			assessmentBodyItems: [],
			studentMinimumQualification: "",
			matricStream: "",
			totalMarks: "",
			practicalMarksPercent: "",
			theoreticalMarksPercent: "",
			totalModules: "",
			examSystemId: "",
			promotionStages: "",
			termCount: "",
			hasOjt: false,
			ojtDuration: "",
			courseCode: "",
			trainingHours: "",
			notificationDate: "",
			version: "",
			courseEquivalence: "",
			competencyPointIds: [],
			competencyPointItems: [],
			minAge: "",
			maxAge: "",
			relaxationPeriod: "",
		},
		laboratories: {
			laboratories: [],
		},
		facultyDetails: {
			facultyQualificationId: [],
			facultyQualificationItems: [],
			facultyBriefRequirements: "",
			facultyExperienceArea: "",
			facultyExperienceYears: 0,
			totalFacultyMemberCount: 0,
		},
		attachments: {
			items: [createDefaultAttachmentItem()],
		},
		currentStep: 0,
		isFormValid: false,
	};
}
